module.exports = __webpack_public_path__ + "img/wrapbg7.de97eec7.png";